export default (baseUrl) => ({
  baseUrl: baseUrl,
  loading: false,
  getErrorsForPage(page) {
    this.loading = true;
    window.axios.get(this.baseUrl + `?page=${page}`).then((resp) => {
      Alpine.morph(this.$root, resp.data);
      this.loading = false;
    });
  },
});
